import { AppSessionCheckService } from './app-session-check.service';
import { APP_INITIALIZER } from '@angular/core';

const sessionKeysToRemove = [
  'userBYCGoalsInfo',
  'userClaimsInfo',
  'userInfo',
  'userPermissions',
  'userPreferences',
  'userProfile',
  'userProfileFetchInfo',
  'userCompanyMappingInfo',
  'activeBeneInfo',
  'isRecommendArticleInfoFetched',
  'pruAnalyticsEvents',
  'forYouLoadLoggedInfo',
  'userRoles',

  'userBUs',
  'currentDdo',
  'userLinkGoals',
  'userMessages',
  'userPzn',
];

// this function is exported due to AOT compile error: Function expressions are not supported in decorators in 'appInitializerSessionCheck'
export function appInitializerSessionCheckFactory(appSessionCheckService: AppSessionCheckService) {
  return () =>
    appSessionCheckService.handleApplicationSessionIntegrity(sessionKeysToRemove);
}

export const appInitializerSessionCheck = {
  provide: APP_INITIALIZER,
  useFactory: appInitializerSessionCheckFactory,
  deps: [AppSessionCheckService],
  multi: true
};
